export enum PlannedServiceType {
  SecuritiesBrokerage = 'SecuritiesBrokerage', // Брокерское обслуживание на рынке ценных бумаг
  SingleTransactions = 'SingleTransactions', // Проведение разовых сделок
  PortfolioManagement = 'PortfolioManagement', // Доверительное управление инвестиционным портфелем
  PaymentServices = 'PaymentServices', // Услуги по обслуживанию платежей
  Other = 'Other', // Другое
}

export enum InvestmentPurposeAndNatureDurationType {
  MoreThanThreeYears = 'MoreThanThreeYears', // Более трех лет
  OneToThreeYears = 'OneToThreeYears', // От одного до трех лет
  LessThanOneYear = 'LessThanOneYear', // Менее одного года
  DailyTrading = 'DailyTrading', // Ежедневная торговля
}

export enum InvestmentObjectiveType {
  CapitalPreservation = 'CapitalPreservation', // Защита капитала
  CapitalGrowth = 'CapitalGrowth', // Прирост капитала
  Speculation = 'Speculation', // Спекуляция
  IncomeGeneration = 'IncomeGeneration', // Получение доходов
  Other = 'Other', // Другое
}

export interface LegalClientInvestmentPurposeAndNatureEntity {
  plannedServices: PlannedServiceType[];
  otherPlannedServices?: string;
  investmentDuration: InvestmentPurposeAndNatureDurationType;
  investmentObjectives: InvestmentObjectiveType[];
  otherInvestmentObjective?: string;
}
